module.exports = __webpack_public_path__ + "static/007_body-as-landscape-e4b910b0f721590538fa724007641cc5.gif";